import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Autorizações',
    path: '/academico/autorizacoes',
    name: 'autorizacoes',
    component: () => import('@/views/academico/autorizacoes/Index.vue'),
    meta: {
      isLegacy: false,
      // Só a própria da tela. A do cadastro do estudante no legado (300100200) entrava aqui de
      // transição e saiu: tela nova não divide permissão com tela do legado.
      permissions: [eTipoPermissao.AUTORIZACOESELETRONICAS_MENU_300100900],
    },
    goesToMenu: true,
  },
];
